import {ChevronRightIcon} from '../../../icon';

import {DetailsList} from '../../details-list/details-list';

import styles from './session-details.module.css';

export type Session = {
    numVisits: number;
    totalVisitDuration: string;
    isUnknownDuration: boolean;
};

interface Props extends Session {
    onExpandDetails: () => void;
}

export function SessionDetails(props: Props) {
    return (
        <button onClick={props.onExpandDetails} className={styles['session-details']}>
            <DetailsList
                details={[
                    {
                        key: 'time-on-site',
                        name: 'Time on site',
                        value: props.totalVisitDuration,
                        isFullWidth: false,
                        popoverInfo: props.isUnknownDuration
                            ? 'Browsers may have blocked the ability to track and view this data.'
                            : undefined,
                    },
                    {
                        key: 'page-visits',
                        name: 'Page visits',
                        value: props.numVisits,
                        isFullWidth: false,
                    },
                ]}
            />
            <div className={styles['icon-container']}>
                <ChevronRightIcon size={15} wrapWithDiv={false} />
            </div>
        </button>
    );
}
